export default "__VITE_ASSET__DhOd1e7d__"